import { DomainsApiConfig, DomainsPermissions } from '@wix/domains-serverless-interface';
import { DomainsAggregationsConfig } from '@wix/domains-serverless-interface/react-kit';
const ANONYMOUS_DOMAINS_ACCOUNT = {
  hasValidVouchers: false,
  domainPermissions: [DomainsPermissions.AccountLevelPurchaseDomain],
  vouchers: [],
  coupons: [],
  unassignedDomains: [],
  assignedDomains: {},
  sites: [],
  domains: []
};
const ANONYMOUS_CAN_CHANGE_DOMAIN_OWNER = {
  canChangeOwner: false
};
const ANONYMOUS_CAN_TRANSFER_IN_DOMAIN = {
  canTransferIn: false
};
export const ANONYMOUS_SETTLEMENTS = [{
  methodConfig: DomainsApiConfig.domainsAccount,
  data: ANONYMOUS_DOMAINS_ACCOUNT
}, {
  methodConfig: DomainsApiConfig.canChangeDomainOwner,
  data: ANONYMOUS_CAN_CHANGE_DOMAIN_OWNER
}, {
  methodConfig: DomainsAggregationsConfig.canTransferInDomain,
  data: ANONYMOUS_CAN_TRANSFER_IN_DOMAIN
}];
//# sourceMappingURL=anonymousSettlements.js.map